(() => {
  const form = document.getElementById('KRWelcomeSignup');
  const dialog = document.getElementById('KRWelcomeDialog');
  if (!form) return;
  const read = (storage, key) => { try { return storage.getItem(key); } catch { return null; } };
  const write = (storage, key, value) => { try { storage.setItem(key, value); } catch {} };
  const pendingKey = 'kr_welcome_signup_pending';
  const success = !!form.querySelector('[data-kr-welcome-success]');
  form.addEventListener('submit', () => {
    if (form.checkValidity()) write(sessionStorage, pendingKey, dialog?.open ? 'welcome_popup' : 'welcome_signup');
  });
  if (success) {
    write(localStorage, 'kr_welcome_subscribed', '1');
    const source = read(sessionStorage, pendingKey);
    try { sessionStorage.removeItem(pendingKey); } catch {}
    if (source) {
      const detail = { event: 'kr_email_signup_success', offer: 'WELCOME10', source };
      document.dispatchEvent(new CustomEvent('kr:email-signup', { detail }));
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(detail);
      if (window.Shopify?.analytics?.publish) window.Shopify.analytics.publish('kr_email_signup_success', { offer: 'WELCOME10', source });
    }
  }
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const originalParent = form.parentNode;
  const originalNext = form.nextSibling;
  const host = dialog.querySelector('.kr-welcome-dialog-form');
  let previousFocus;
  const open = () => {
    if (dialog.open || document.querySelector('dialog[open]')) return false;
    previousFocus = document.activeElement;
    host.append(form);
    dialog.showModal();
    write(sessionStorage, 'kr_welcome_seen', '1');
    return true;
  };
  dialog.querySelector('.kr-welcome-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('keydown', event => {
    if (event.key !== 'Tab') return;
    const controls = [...dialog.querySelectorAll('button,input:not([type="hidden"]),a[href],select,textarea,[tabindex="0"]')].filter(el => !el.disabled && el.getClientRects().length);
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
  });
  dialog.addEventListener('click', event => {
    const bounds = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) dialog.close();
  });
  dialog.addEventListener('close', () => {
    write(localStorage, 'kr_welcome_dismissed', String(Date.now()));
    originalParent.insertBefore(form, originalNext);
    if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
  });
  document.querySelectorAll('a[href="#kr-welcome-signup"]').forEach(link => {
    link.addEventListener('click', event => { if (open()) event.preventDefault(); });
  });
  if (success || form.querySelector('[aria-invalid="true"]')) { open(); return; }
  if (window.Shopify?.designMode || dialog.dataset.subscribed === 'true') return;
  const dismissed = Number(read(localStorage, 'kr_welcome_dismissed'));
  if (read(localStorage, 'kr_welcome_subscribed') || read(sessionStorage, 'kr_welcome_seen') || (dismissed && Date.now() - dismissed < 30 * 86400000)) return;
  const timer = setTimeout(() => {
    if (document.visibilityState !== 'visible' || document.activeElement?.matches('input,textarea,select,[contenteditable="true"]')) return;
    open();
  }, 7000);
  window.addEventListener('pagehide', () => clearTimeout(timer), { once: true });
})();

